import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import Layout  from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExternalLinkSquareAlt, faLink ,faExternalLinkAlt, faChevronRight, faChevronDown, faWindowClose, faDownload, faExclamationTriangle, faExclamationCircle, faLightbulb, faTruckMonster} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BJumbotron } from 'bootstrap-vue'
import { Plotly } from 'vue-plotly'
import JsonCSV from 'vue-json-csv'
import ReadMore from 'vue-read-more';
import VueEvents from 'vue-events'
  Vue.use(VueEvents)
Vue.use(BootstrapVue)
Vue.use(Layout)
Vue.use(ReadMore);
library.add(faExternalLinkSquareAlt,faLink,faExternalLinkAlt,faChevronRight,faChevronDown,faWindowClose,faDownload,faExclamationTriangle,faExclamationCircle,faLightbulb)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('b-jumbotron', BJumbotron)
Vue.component('Plotly', Plotly)
Vue.component('downloadCsv', JsonCSV)
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css"

Vue.component('multiselect', Multiselect)

Vue.config.productionTip = true
Vue.prototype.$hostname = (Vue.config.productionTip) ? '' : 'http://localhost:6004/'

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})
